export default "__VITE_ASSET__500f79b8__"